import { type FormComponentBaseProps } from "@common/controls/Form/Field/component";
import { CardElement } from "@stripe/react-stripe-js";
import { type StripeCardElementChangeEvent, type StripeCardElementOptions } from "@stripe/stripe-js";
import classNames from "classnames";
import React from "react";
import { getStripeInputStyle } from "./lib";

export type StripeCartInputProps = FormComponentBaseProps & {
  onChange?: (value: string) => void;
  style?: React.CSSProperties;
};
const StripeCardInput = (props: StripeCartInputProps) => {
  const cardElementOptions = React.useMemo((): StripeCardElementOptions => {
    const style = props.style ? getStripeInputStyle(props.style) : undefined;

    return {
      hidePostalCode: true,
      style: style
        ? {
            base: {
              ...style.input,
              "::placeholder": style.placeholder
            }
          }
        : undefined
    };
  }, [props.style]);

  const onChange = React.useCallback(
    (e: StripeCardElementChangeEvent) => {
      if (e.complete && props.onChange) props.onChange("dummy");
    },
    [props.onChange]
  );

  return (
    <div className={classNames(props.className, "card_input")}>
      <CardElement options={cardElementOptions} onChange={onChange} />
    </div>
  );
};
export default StripeCardInput;
